import * as React from 'react';
import TextField from '@material-ui/core/TextField';

interface Props {
  errorText?: string;
  inError: boolean;
  label?: string;
  onChange: (value: string) => void;
  value: string;
}

function TextBox(props: Props) {
  function onChange(event: Object) {
    props.onChange(event.target.value);
  }

  const hasError = props.inError && Boolean(props.errorText) && props.errorText !== '';

  return (
    <TextField
      label={props.label}
      value={props.value}
      error={hasError}
      helperText={hasError ? props.errorText : undefined}
      onChange={onChange}
      fullWidth
    />
  );
}

TextBox.defaultProps = {
  inError: false,
};

export default TextBox;



// WEBPACK FOOTER //
// ./src/common/components/ui/TextBox.js